export default __webpack_public_path__ + "static/media/IMG_3905.8b52bc6e.jpeg";